import React from 'react';

// Styles
import './styles.scss';

interface Props {
    children?: React.ReactNode;
}

export default class DisableUserSelect extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { children } = this.props;

        if (!children) {
            return null;
        }

        return <div className="disable-user-select">{children}</div>;
    }
}
